/**
 * Есть ли что показывать в блоге.
 *
 * Раздел появляется в меню, только когда опубликована хотя бы одна статья:
 * пустой блог с надписью «материалов пока нет» выглядит хуже, чем его
 * отсутствие. Лента рекомендаций внизу статьи включается с пятого материала —
 * подборка из двух карточек читается не как подборка, а как недоделка.
 *
 * Считаем отдельным запросом с pageSize=1: нужен только счётчик из пагинации,
 * тянуть ради него две сотни статей в шапку каждой страницы незачем.
 */

/** С какого числа материалов показываем ленту рекомендаций. */
export const BLOG_FEED_MIN = 5

export const useBlogAvailability = () => {
  const { data } = useApi<{ pagination?: { total?: number } }>('blog/articles', {
    key: 'blog-total',
    params: { pageSize: 1 },
  })

  const total = computed(() => Number(data.value?.pagination?.total ?? 0))

  return {
    total,
    /** Есть хотя бы одна статья — раздел живой */
    hasBlog: computed(() => total.value > 0),
    /** Материалов хватает на ленту рекомендаций */
    hasFeed: computed(() => total.value >= BLOG_FEED_MIN),
  }
}
